export default __webpack_public_path__ + "static/media/8788f309ff9a9cd2.be23ffbfa1c38a42191bebfdd14b3cd9.svg";